export const raffleContentStyle = {
	wrapper: {
		marginBottom: '40px',
		'@media (max-width: 1199.98px)': {
			marginBottom: '24px',
		},
		'@media (max-width: 639.98px)': {
			marginBottom: '20px',
		},
	},

	raffle: {
		display: 'flex',
		alignItems: 'center',
		gap: '12px',
		marginBottom: '12px',
		'@media (max-width: 639.98px)': {
			flexWrap: 'wrap',
		},
	},

	subtitle: {
		fontWeight: 400,
	},

	title: {
		marginRight: '12px',
	},

	prizeLogo: {
		marginTop: '20px',
		maxWidth: '471px',

		'& .MuiFormLabel-root': {
			position: 'absolute',
			top: '-20px',
		},
		'@media (max-width: 1199.98px)': {
			maxWidth: '100%',
		},
	},

	dateWrapper: {
		display: 'flex',
		gap: '24px',
		marginBottom: '12px',
		'@media (max-width: 1023.98px)': {
			flexDirection: 'column',
			gap: '16px',
		},
		'@media (max-width: 639.98px)': {
			gap: '12px',
		},
	},

	date: {
		display: 'flex',
		gap: '12px',

		'& > div': {
			width: 'auto',
		},

		'@media (max-width: 639.98px)': {
			flexDirection: 'column',
			'& > div': {
				width: '100%',
			},
		},
	},

	dateMonthYear: {
		maxWidth: '100%',
		// width: '249px',
		'@media (max-width: 639.98px)': {
			width: '100%',
		},
	},

	time: {
		'& > div:first-of-type': {
			maxWidth: '120px',
			width: '100%',
		},
		'@media (max-width: 639.98px)': {
			'& > div:first-of-type': {
				maxWidth: '100%',
				width: '100%',
			},
		},
	},

	prize: {
		display: 'flex',
		gap: '24px',
		'@media (max-width: 1023.98px)': {
			gap: '20px',
		},
		'@media (max-width: 639.98px)': {
			gap: '16px',
		},
	},

	prizeLogoWrapper: {
		maxWidth: '471px',
		height: '260px',
		width: '100%',
		'@media (max-width: 1199.98px)': {
			maxWidth: '100%',
		},
		'@media (max-width: 639.98px)': {
			height: '220px',
		},
	},

	raffleDescriptionWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
		width: '100%',
	},

	raffleDescription: {
		maxWidth: '100%',

		'&.MuiFormControl-root .MuiInputBase-root': {
			height: '100%',
			maxHeight: '107px',
			width: '100%',
		},
	},

	ticketPrice: {
		'& .MuiInputBase-input': {
			padding: '0 !important',
		},
	},

	tickets: {
		// width: '100% !important',
		'& .MuiInputBase-input': {
			padding: '0 12px 0 !important',
		},
	},
};
